export enum ROLE {
  SELLER = "Seller",
  BUYER = "Buyer",
}

type DepthLimit<T, D extends number = 2> = D extends 0
  ? string
  : T extends object
  ? {
      [K in keyof T]: T[K] extends object
        ? `${string & K}.${DepthLimit<T[K], Decrement[D]>}`
        : `${string & K}`;
    }[keyof T]
  : `${string}`;

export enum LANG {
  EN = "en",
  AR = "ar",
}
type Decrement = [never, 0, 1, 2, 3, 4];

export type ObjectKeysAsString<T> = DepthLimit<T>;
